import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

/// O país que vale para quem digita sem "+". A empresa ainda não declara país; o HUE atende no
/// Brasil, e o dia em que atender fora é o dia de este padrão virar dado da empresa (ADR 0037).
export const DEFAULT_PHONE_COUNTRY: CountryCode = 'BR';

export interface PhoneReading {
  /// Formato internacional, o que se grava: `+5511982314410`.
  e164: string;
  /// País pelo código (`BR`, `PT`…), ou nulo quando o código é compartilhado e o número não diz.
  country: string | null;
  /// Como a pessoa lê: nacional no país da empresa, internacional fora dele.
  display: string;
  /// Possível mas fora da numeração do país — um celular brasileiro de 7 dígitos, por exemplo.
  /// Aceita-se e avisa-se: recusar faria a recepção inventar um número para salvar a ficha.
  suspicious: boolean;
}

/// Lê um telefone digitado ou gravado. Nulo quando não há número que se possa discar — curto ou
/// longo demais para qualquer país.
export function readPhone(
  input: string | null | undefined,
  defaultCountry: CountryCode = DEFAULT_PHONE_COUNTRY,
): PhoneReading | null {
  const value = (input ?? '').trim();
  if (!value) return null;
  const phone = parsePhoneNumberFromString(value, defaultCountry);
  if (!phone?.isPossible()) return null;
  const country = phone.country ?? null;
  return {
    e164: phone.number,
    country,
    display: country === defaultCountry ? phone.formatNational() : phone.formatInternational(),
    suspicious: !phone.isValid(),
  };
}

/// Telefone para exibir: o gravado lido e formatado, ou o texto como veio quando não se lê — o
/// número antigo que a migração não soube converter continua aparecendo.
export function formatPhone(value: string | null | undefined): string | null {
  if (!value) return null;
  return readPhone(value)?.display ?? value;
}
